import { render, staticRenderFns } from "./FormFoto.vue?vue&type=template&id=139a9b55&"
import script from "./FormFoto.vue?vue&type=script&lang=js&"
export * from "./FormFoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports